export default {
  startedModal: {
    container: 'dt.loyalty.missions.startedModal.container',
    cta: 'dt.loyalty.missions.startedModal.cta',
  },
  completedModal: {
    container: 'dt.loyalty.missions.completedModal.container',
    gotItButton: 'dt.loyalty.missions.completedModal.gotItButton',
  },
};
